const GoArrow = () => (
  <svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg" className="go-arrow">
    <path d="M0.786133 18.5935L10.7875 9.72493L0.786132 0.856346" stroke="currentColor" strokeLinecap="round" />
  </svg>
)

export default GoArrow;